export default __webpack_public_path__ + "static/media/tutorial02.44629ae1.jpg";